import { priorityLabels, statusLabels, type TicketPriority, type TicketStatus } from '@/mocks/superAdminSupport';

interface SupportFiltersProps {
  activeStatus: string;
  onStatusChange: (status: string) => void;
  activePriority: string;
  onPriorityChange: (priority: string) => void;
  statusCounts: Record<string, number>;
  priorityCounts: Record<string, number>;
}

const statusFilterKeys = ['todos', 'open', 'in_progress', 'waiting_customer', 'resolved', 'closed'];
const priorityFilterKeys = ['todos', 'low', 'normal', 'high', 'urgent'];

const statusIcons: Record<string, string> = {
  open: 'ri-checkbox-blank-circle-line',
  in_progress: 'ri-loader-4-line',
  waiting_customer: 'ri-user-voice-line',
  resolved: 'ri-check-double-line',
  closed: 'ri-close-circle-line',
};

const priorityIcons: Record<string, string> = {
  low: 'ri-arrow-down-line',
  normal: 'ri-subtract-line',
  high: 'ri-arrow-up-line',
  urgent: 'ri-alert-line',
};

export default function SupportFilters({
  activeStatus,
  onStatusChange,
  activePriority,
  onPriorityChange,
  statusCounts,
  priorityCounts,
}: SupportFiltersProps) {
  return (
    <div className="space-y-3">
      {/* Status filters */}
      <div className="flex items-center gap-1.5 flex-wrap">
        <span className="text-foreground-400 text-[10px] font-semibold uppercase tracking-wider mr-1">Estado</span>
        {statusFilterKeys.map((s) => (
          <button
            key={s}
            onClick={() => onStatusChange(s)}
            className={`inline-flex items-center gap-1 px-2.5 py-1.5 rounded-full text-[10px] font-medium whitespace-nowrap cursor-pointer transition-all
              ${activeStatus === s
                ? 'bg-foreground-950 text-background-50'
                : 'bg-background-50 border border-background-200 text-foreground-600 hover:border-foreground-300 hover:text-foreground-800'
              }`}
          >
            {s !== 'todos' && <i className={`${statusIcons[s]} text-[9px]`}></i>}
            <span>{s === 'todos' ? 'Todos' : statusLabels[s as TicketStatus]}</span>
            <span className={`text-[9px] ${activeStatus === s ? 'text-background-50/70' : 'text-foreground-400'}`}>
              {statusCounts[s] ?? 0}
            </span>
          </button>
        ))}
      </div>

      {/* Priority filters */}
      <div className="flex items-center gap-1.5 flex-wrap">
        <span className="text-foreground-400 text-[10px] font-semibold uppercase tracking-wider mr-1">Prioridad</span>
        {priorityFilterKeys.map((p) => (
          <button
            key={p}
            onClick={() => onPriorityChange(p)}
            className={`inline-flex items-center gap-1 px-2.5 py-1.5 rounded-full text-[10px] font-medium whitespace-nowrap cursor-pointer transition-all
              ${activePriority === p
                ? 'bg-foreground-950 text-background-50'
                : 'bg-background-50 border border-background-200 text-foreground-600 hover:border-foreground-300 hover:text-foreground-800'
              }`}
          >
            {p !== 'todos' && <i className={`${priorityIcons[p]} text-[9px]`}></i>}
            <span>{p === 'todos' ? 'Todas' : priorityLabels[p as TicketPriority]}</span>
            <span className={`text-[9px] ${activePriority === p ? 'text-background-50/70' : 'text-foreground-400'}`}>
              {priorityCounts[p] ?? 0}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}